import api from "./api";

const route = "/invoices";

const InvoicesService = {
  getInvoices: () => api.get(route),
};
export default InvoicesService;
